import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Импортируем файлы локализации для русского языка
import commonRu from './locales/ru/common.json';
import clubRu from './locales/ru/club.json';
import tournamentRu from './locales/ru/tournament.json';
import adminRu from './locales/ru/admin.json';
import subscriptionRu from './locales/ru/subscription.json';
import authRu from './locales/ru/auth.json';
import feedbackRu from './locales/ru/feedback.json';

// Импортируем файлы локализации для английского языка
import commonEn from './locales/en/common.json';
import clubEn from './locales/en/club.json';
import tournamentEn from './locales/en/tournament.json';
import adminEn from './locales/en/admin.json';
import subscriptionEn from './locales/en/subscription.json';
import authEn from './locales/en/auth.json';
import feedbackEn from './locales/en/feedback.json';

i18n
  // Определение языка
  .use(LanguageDetector)
  // Передача экземпляра i18n в react-i18next
  .use(initReactI18next)
  // Инициализация i18next
  .init({
    resources: {
      ru: {
        common: commonRu,
        club: clubRu,
        tournament: tournamentRu,
        admin: adminRu,
        subscription: subscriptionRu,
        auth: authRu,
        feedback: feedbackRu,
      },
      en: {
        common: commonEn,
        club: clubEn,
        tournament: tournamentEn,
        admin: adminEn,
        subscription: subscriptionEn,
        auth: authEn,
        feedback: feedbackEn,
      },
    },
    fallbackLng: 'ru',
    supportedLngs: ['ru', 'en'],
    defaultNS: 'common',
    ns: ['common', 'club', 'tournament', 'admin', 'subscription', 'auth', 'feedback'],
    interpolation: {
      escapeValue: false, // React уже экранирует значения
    },
    detection: {
      // Определяем язык из localStorage или браузера
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  });

export default i18n;